import React, { useState, useEffect } from 'react';
import SelectFieldCheckbox from './SelectFieldCheckbox';
import ErrorMessage from '../../../ErrorMessage';
import OfficeService from '../../../../Services/OfficeService';
import OfficeHelper from '../../../../Helpers/ModelHelpers/OfficeHelper';

/**
 * Office group selector (CD-5311). The value is an office group id. The options are the groups of the office list:
 * the shared groups and the offices' own groups, which carry the offices' names.
 */
const OfficeGroupSelect = ({
  value = null,
  className = 'w-100 form-control form-control-sm',
  filterCleared = false,
  fieldName = 'defaultFieldname',
  onChange = (_fieldName, _officeGroupId) => {},
  showSelectFilterAt = 10,
}) => {
  const [selectValues, setSelectValues] = useState([{ label: 'Choose one...', value: '', disabled: false }]);

  useEffect(() => {
    OfficeService.GetOfficesForSelect()
      .then((offices) => {
        setSelectValues([
          { label: 'Choose one...', value: '', disabled: false },
          ...OfficeHelper.GetOfficeGroups(offices).map((officeGroup) => ({
            label: officeGroup.name,
            value: officeGroup.officeGroupId,
            disabled: false,
          })),
        ]);
      })
      .catch(() => {
        ErrorMessage.SetErrorMessage('OGS20');
      });
  }, []);

  return (
    <SelectFieldCheckbox
      value={value}
      className={className}
      fieldName={fieldName}
      onChange={onChange}
      filterCleared={filterCleared}
      selectValues={selectValues}
      showSelectFilterAt={showSelectFilterAt}
    />
  );
};

export default OfficeGroupSelect;
